// Razorpay Configuration
// TODO: Replace with your actual Razorpay Key ID from https://dashboard.razorpay.com/app/keys
// For production, always use environment variables: process.env.REACT_APP_RAZORPAY_KEY_ID
export const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID || '';

// Franchise payment details
export const FRANCHISE_FEE = {
  baseAmount: 100000, // Rs. 1,00,000
  gst: 18000, // Rs. 18,000 (18% GST)
  totalAmount: 118000, // Rs. 1,18,000
  currency: 'INR',
};

// Razorpay checkout options
export const getRazorpayOptions = ({
  keyId = RAZORPAY_KEY_ID,
  orderId,
  amount,
  currency = FRANCHISE_FEE.currency,
  customerName,
  customerEmail,
  customerPhone,
  onSuccess,
  onFailure,
}) => {
  return {
    key: keyId,
    amount, // Razorpay Checkout expects amount in paise when an order is supplied
    currency,
    name: 'Douglas & McCartney',
    description: 'Franchise Agreement Fee',
    image: '/logo192.png', // Your company logo
    order_id: orderId, // Generated from backend
    handler: function (response) {
      onSuccess({
        razorpay_payment_id: response.razorpay_payment_id,
        razorpay_order_id: response.razorpay_order_id,
        razorpay_signature: response.razorpay_signature,
      });
    },
    prefill: {
      name: customerName,
      email: customerEmail,
      contact: customerPhone,
    },
    notes: {
      purpose: 'Franchise Agreement Payment',
      type: 'Franchise Fee',
    },
    theme: {
      color: '#d4af37', // Golden color matching your theme
    },
    modal: {
      ondismiss: function () {
        onFailure?.({ reason: 'Payment cancelled by user' });
      },
    },
  };
};

